<mat-toolbar role="heading">
	<mat-toolbar-row>
		<button mat-icon-button type="button" (click)="drawerInput()?.toggle()" i18n-aria-label aria-label="Toggle sidenav">
			<mat-icon>menu</mat-icon>
		</button>
		<a [routerLink]="['/']" rel="bookmark">
			<img ngSrc="icons/icon-192x192.png" i18n-alt alt="home" width="64" height="64" priority>
		</a>
		<div class="spacer"></div>
	</mat-toolbar-row>
</mat-toolbar>
